export async function clearAllSiteData() {
  try {
    const cacheNames = await caches.keys()
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)))
  } catch (error) {
    console.error('Error clearing Cache Storage:', error)
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(
      registrations.map((registration) => registration.unregister()),
    )
  } catch (error) {
    console.error('Error unregistering Service Workers:', error)
  }

  try {
    const databases = await indexedDB.databases()
    databases.forEach((db) => {
      if (db.name) indexedDB.deleteDatabase(db.name)
    })
  } catch (error) {
    console.error('Error clearing IndexedDB:', error)
  }

  console.log('All site data cleared successfully')
}
